import gql from 'graphql-tag';

const importFinancingGrowerReport = gql`
  mutation importFinancingGrowerReport($fileId: Int!) {
    importFinancingGrowerReport(fileId: $fileId)
  }
`;

const financingBrazilDatasets = gql`
  query {
    financingBrazilDatasets {
      id
      documentName
      documentUrl
    }
  }
`;

const financingBrazilKMLs = gql`
  query {
    financingBrazilKMLs {
      id
      documentName
      documentUrl
      createdAt
    }
  }
`;

const createFinancingDatasetDocument = gql`
  mutation createFinancingDatasetDocument($data: FinancingDocumentCreateInput!) {
    createFinancingDatasetDocument(data: $data) {
      id
      documentName
      documentUrl
    }
  }
`;

const createFinancingKMLDocument = gql`
  mutation createFinancingKMLDocument($data: FinancingDocumentCreateInput!) {
    createFinancingKMLDocument(data: $data) {
      documentName
      documentUrl
    }
  }
`;

const financingBrazilKMLPresignedUploadUrl = gql`
  query financingBrazilKMLPresignedUploadUrl($data: FinancingFileUploadUrlInput!) {
    financingBrazilKMLPresignedUploadUrl(data: $data) {
      presignedUrl
      remoteFileName
    }
  }
`;

const financingBrazilDatasetPresignedUploadUrl = gql`
  query financingBrazilDatasetPresignedUploadUrl($data: FinancingFileUploadUrlInput!) {
    financingBrazilDatasetPresignedUploadUrl(data: $data) {
      presignedUrl
      remoteFileName
    }
  }
`;

export {
  importFinancingGrowerReport,
  financingBrazilDatasets,
  createFinancingDatasetDocument,
  financingBrazilKMLs,
  createFinancingKMLDocument,
  financingBrazilKMLPresignedUploadUrl,
  financingBrazilDatasetPresignedUploadUrl
};
